// Shared light-theme styles for Digital module
export const C = {
  bg:         '#F5F5F5',
  surface:    '#FFFFFF',
  surface2:   '#FAFAFA',
  surface3:   '#F0EDE8',
  border:     '#E0E0E0',
  text:       '#0A0A0A',
  text2:      '#4A4A4A',
  text3:      '#9A8A7A',
  gold:       '#C19A6B',
  goldDark:   '#9B7E54',
  goldLight:  '#D4B896',
  goldBg:     '#FBF7F2',
  goldBorder: '#E8D5BC',
  green:      '#2A7A5A',
  greenDim:   '#E8F5EF',
  amber:      '#B8860B',
  amberDim:   '#FEF9E7',
  red:        '#A02020',
  redDim:     '#FDEAEA',
  blue:       '#1A4A8A',
  blueDim:    '#EBF0F9',
};

export const STATUS_COLOR = {
  draft:    C.text3,
  review:   C.amber,
  approved: C.green,
  archived: '#AAA',
};
export const STATUS_ICON = {
  draft: '✏️', review: '🔍', approved: '✅', archived: '📦',
};

const base = {
  fontFamily: "'Inter', sans-serif",
};

export const S = {
  page: {
    ...base,
    padding: '32px 36px',
    background: C.bg,
    minHeight: '100%',
  },
  h1: {
    margin: 0, fontSize: 22, fontWeight: 800,
    color: C.text, fontFamily: "'Inter', sans-serif",
  },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: {
    textAlign: 'left', padding: '8px 14px', fontSize: 11,
    fontWeight: 700, color: C.text3, textTransform: 'uppercase',
    letterSpacing: '.06em', borderBottom: `2px solid ${C.goldBorder}`,
    background: C.goldBg,
  },
  tr: {
    cursor: 'pointer', borderBottom: `1px solid ${C.border}`,
    transition: 'background .1s',
  },
  td: { padding: '12px 14px', fontSize: 13, color: C.text, background: C.surface },
  card: {
    background: C.surface, border: `1px solid ${C.border}`,
    borderRadius: 10, padding: '14px 18px',
    boxShadow: '0 1px 4px rgba(0,0,0,.07)',
  },
  planRow: {
    background: C.surface, border: `1px solid ${C.border}`,
    borderRadius: 10, padding: '14px 16px',
    cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12,
    boxShadow: '0 1px 3px rgba(0,0,0,.05)',
    transition: 'box-shadow .12s',
  },
  btnPrimary: {
    background: C.gold, color: '#fff', border: 'none', borderRadius: 7,
    padding: '8px 16px', fontWeight: 700, fontSize: 13, cursor: 'pointer',
    fontFamily: "'Inter', sans-serif",
  },
  btnGhost: {
    background: 'transparent', border: `1px solid ${C.border}`, borderRadius: 7,
    padding: '6px 14px', color: C.text2, fontSize: 12, cursor: 'pointer',
    fontFamily: "'Inter', sans-serif",
  },
  btnAction: {
    background: 'transparent', border: `1px solid ${C.border}`, borderRadius: 6,
    padding: '5px 10px', color: C.text3, fontSize: 11, cursor: 'pointer',
    fontFamily: "'Inter', sans-serif",
  },
  input: {
    width: '100%', boxSizing: 'border-box',
    background: C.surface, border: `1px solid ${C.border}`, borderRadius: 7,
    padding: '9px 12px', color: C.text, fontSize: 13, outline: 'none',
    fontFamily: "'Inter', sans-serif",
  },
  label: {
    fontSize: 11, fontWeight: 600, color: C.text3,
    textTransform: 'uppercase', letterSpacing: '.06em',
    marginBottom: 5, display: 'block',
  },
  search: {
    width: '100%', boxSizing: 'border-box', marginBottom: 16,
    background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8,
    padding: '9px 14px', color: C.text, fontSize: 13, outline: 'none',
    fontFamily: "'Inter', sans-serif",
  },
  empty: {
    background: C.surface, border: `1px solid ${C.border}`, borderRadius: 12,
    padding: 40, textAlign: 'center', color: C.text3, fontSize: 14,
  },
  muted: { color: C.text3, fontSize: 13 },
  badge: (color) => ({
    display: 'inline-block', padding: '2px 9px', borderRadius: 20,
    fontSize: 11, fontWeight: 700, color, background: color + '18',
    border: `1px solid ${color}44`,
  }),
};

export default S;
